import { StateUpdaterMap } from "src/model/manager/state-manager";
import { ShoppingCartItxDto } from "src/api/customer";
import { AppState } from "..";
import { getUnavailableIDProducts, hasChangedItems, hasUnavailableItems } from "src/model/utils/cart";
import { ErrorMessage } from "src/model/error-message";
import { Address } from "src/api/address";

export interface CartActions {
    CART_SET: ShoppingCartItxDto;
    CART_UNSET: null;
    CART_ADD: number;
    CART_REMOVE: number;
    CART_UPDATED: ShoppingCartItxDto;
    CART_UPDATE_ERROR: ErrorMessage;
    CART_UPDATE_DISMISS_ERROR: undefined;
    CART_CHECK_PRODUCT: number;
    CART_CHECK_PRODUCT_ERROR: ErrorMessage;
    CART_CHECK_FINISHED: undefined;
    CART_SET_PAYMENT_ELEMENT_EXPANDED: boolean;
    CART_SHOW_ADDRESS_ALERT: boolean; 
    CART_SET_ADDRESSES: Address[];
    
}

export const cartActions: StateUpdaterMap<AppState, CartActions> = {
    CART_SET: (cartData, { cart }) => ({
        cart: {
            ...cart,
            content: cartData,
            lastLoad: Date.now(),
            hasChangedItems: hasChangedItems(cartData),
            hasUnavailableItems: hasUnavailableItems(cartData),
            unavailableIdItems: getUnavailableIDProducts(cartData)
        }
    }),
    CART_UNSET: (_, prevState) => ({
        cart: {
            content: null,
            lastLoad: Date.now(),
            hasChangedItems: false,
            hasUnavailableItems: false,
            unavailableIdItems: [],
            update: null,
            productCheck: null,
            showAddressAlert: false,
        }
    }),
    CART_ADD: (productId, { cart }) => ({
        cart: {
            ...cart,
            update: {
                productId,
                type: "ADDING",
                error: null
            }
        }
    }),
    CART_REMOVE: (productId, { cart }) => ({
        cart: {
            ...cart,
            update: {
                productId,
                type: "REMOVING",
                error: null,
            }
        }
    }),
    CART_UPDATED: (content, { cart }) => ({
        cart: {
            ...cart,
            content,
            lastLoad: Date.now(),
            hasChangedItems: hasChangedItems(content),
            hasUnavailableItems: hasUnavailableItems(content),
            unavailableIdItems: getUnavailableIDProducts(content),
            update: null,
        }
    }),
    CART_UPDATE_ERROR: (error, { cart }) => ({
        cart: {
            ...cart,
            update: {
                ...cart.update,
                error
            }
        }
    }),
    CART_UPDATE_DISMISS_ERROR: (_, { cart }) => ({
        cart: {
            ...cart,
            update: null
        }
    }),
    CART_CHECK_PRODUCT: (productId, { cart }) => ({
        cart: {
            ...cart,
            productCheck: {
                productId,
                error: null
            }
        }
    }),
    CART_CHECK_PRODUCT_ERROR: (error, { cart }) => ({
        cart: {
            ...cart,
            productCheck: {
                ...cart.productCheck,
                error
            }
        }
    }),
    
    CART_CHECK_FINISHED: (_, { cart }) => ({
        cart: {
            ...cart,
            productCheck: null
        }
    }),
    CART_SET_PAYMENT_ELEMENT_EXPANDED: (isExpanded, { cart }) => ({
        cart: {
            ...cart,
            paymentElementExpanded: isExpanded
        }
    }),
    CART_SHOW_ADDRESS_ALERT: (showAlert, { cart }) => ({
        cart: {
            ...cart,
            showAddressAlert: showAlert
        }
    }),
    CART_SET_ADDRESSES: (addresses, { checkout }) => ({
        checkout: {
            ...checkout,
            addresses: addresses
        }
    })   
};